exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-card-qty[data-v-2563f096] {\n  margin-left: -17px;\n  margin-top: 5px;\n}", ""]);

// exports
